import React, { useState, useEffect } from "react";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";

import "./Payslip.css";

export default function Downloadpayslip() {
  const [payslips, setPayslips] = useState([]);
  const [config, setConfig] = useState(null);
  const [selectedPayslips, setSelectedPayslips] = useState([]);

  
  

  const empCode = sessionStorage.getItem("user_id");

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config", err));
  }, []);

  // Fetch payslips using config
  useEffect(() => {
    if (!config || !empCode) return;

    const fetchPayslips = async () => {
      try {
        const response = await fetch(
          `${config.BASE_URL}${config.GET_EMP_PAYSLIPS}`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "RC_EMP_NEW",
            },
            body: JSON.stringify({
              emp_code: empCode
            })
          }
        );

        const data = await response.json();
        if (data.status === "success") {
          setPayslips(data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch payslips", error);
      }
    };

    fetchPayslips();
  }, [config, empCode]);

  const handleCheckboxChange = (id) => {
  setSelectedPayslips((prev) =>
    prev.includes(id)
      ? prev.filter((item) => item !== id)
      : [...prev, id]
  );
};

const handleSelectAll = () => {
  if (selectedPayslips.length === payslips.length) {
    setSelectedPayslips([]);
  } else {
    setSelectedPayslips(payslips.map((p) => p.id));
  }
};



  const numberToWords = (num) => {
  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const convert = (n) => {
    if (n < 20) return a[n];
    if (n < 100)
      return b[Math.floor(n / 10)] + " " + a[n % 10];
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred " +
        convert(n % 100)
      );
    if (n < 100000)
      return (
        convert(Math.floor(n / 1000)) +
        " Thousand " +
        convert(n % 1000)
      );
    if (n < 10000000)
      return (
        convert(Math.floor(n / 100000)) +
        " Lakh " +
        convert(n % 100000)
      );
    return (
      convert(Math.floor(n / 10000000)) +
      " Crore " +
      convert(n % 10000000)
    );
  };

  return convert(num).trim() + " Only";
};


  const handleDownloadPayslip = async (p) => {
  try {
    // Fetch existing PDF template
    const existingPdfBytes = await fetch("/assets/payslip_template.pdf")
      .then((res) => res.arrayBuffer());

    // Load PDF
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const gross =
      parseFloat(p.salary || 0) +
      parseFloat(p.incentive_pay || 0) +
      parseFloat(p.allowances || 0);

    const deductions =
      parseFloat(p.pf || 0) +
      parseFloat(p.tax || 0);

    const net = gross - deductions;
    const netInWords = numberToWords(Math.floor(net));


    // Adjust X, Y according to your template layout
    firstPage.drawText(p.joining_date || "", { x: 177, y: 712, size: 10, font });
    firstPage.drawText(p.pay_period || "", { x: 177, y: 694, size: 10, font });
    firstPage.drawText(p.transaction_id || "", { x: 177, y: 653, size: 10, font });

    firstPage.drawText(p.name, { x: 440, y: 712, size: 10, font });
    firstPage.drawText(p.role, { x: 440, y: 693, size: 10, font });
    firstPage.drawText(p.department, { x: 440, y: 674, size: 10, font });
    
    

    firstPage.drawText(p.salary?.toString() || "0", { x: 220, y: 582, size: 10, font });
    firstPage.drawText(p.incentive_pay?.toString() || "0", { x: 220, y: 565, size: 10, font });
    firstPage.drawText(p.allowances?.toString() || "0", { x: 220, y: 545, size: 10, font });

    firstPage.drawText(gross.toFixed(2), { x: 220, y: 490, size: 10, font });


    firstPage.drawText(p.pf?.toString() || "0", { x: 480, y: 582, size: 10, font });
    firstPage.drawText(p.tax?.toString() || "0", { x: 480, y: 565, size: 10, font });

    firstPage.drawText(deductions.toFixed(2), { x: 480, y: 490, size: 10, font });

    firstPage.drawText(net.toFixed(2), {
      x: 480,
      y: 460,
      size: 12,
      font,
      color: rgb(0, 0.5, 0),
    });

    firstPage.drawText(netInWords, {
        x: 100,
        y: 404,
        size: 12,
        font,
        });

    //Save updated PDF
    const pdfBytes = await pdfDoc.save();

    //Download
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `Payslip_${p.pay_period}.pdf`;
    link.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error generating payslip:", error);
    alert("Failed to generate payslip");
  }
};


  return (
    <div className="download-container">
        <button 
  onClick={() => {
    const selectedData = payslips.filter((p) =>
      selectedPayslips.includes(p.id)
    );

    if (selectedData.length === 0) {
      alert("Please select at least one payslip.");
      return;
    }

    selectedData.forEach((p) => {
      handleDownloadPayslip(p);
    });
  }}
>
  Download Selected
</button>

      <table className="download-table">
        <thead>
        <tr>
            <th>
            <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={
                payslips.length > 0 &&
                selectedPayslips.length === payslips.length
                }
            />
            </th>
            <th>S.No</th>
            <th>Pay Period</th>
            <th>Gross Pay</th>
            <th>Total Deductions</th>
            <th>Net Pay</th>
            <th>Generated Date</th>
        </tr>
        </thead>

        <tbody>
          {payslips.length > 0 ? (
            payslips.map((p, index) => {
              const gross =
                parseFloat(p.salary || 0) +
                parseFloat(p.incentive_pay || 0) +
                parseFloat(p.allowances || 0);

              const deductions =
                parseFloat(p.pf || 0) +
                parseFloat(p.tax || 0);

              const net = gross - deductions;

              return (
                <tr key={index}>
                     <td>
                    <input
                    type="checkbox"
                    checked={selectedPayslips.includes(p.id)}
                    onChange={() => handleCheckboxChange(p.id)}
                    />
                </td>
                  <td>{index + 1}</td> 
                  <td>{p.pay_period}</td>
                  <td>{gross.toFixed(2)}</td>
                  <td>{deductions.toFixed(2)}</td>
                  <td>{net.toFixed(2)}</td>
                  <td>{p.created_at?.slice(0, 10)}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="7">No payslips available.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
